const isLocalBrowser = () =>
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)

export const getBugsnagReleaseStage = () =>
  isLocalBrowser() || process.env.NODE_ENV === 'development'
    ? 'development'
    : (process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE ??
      process.env.NEXT_PUBLIC_ENV ??
      process.env.NODE_ENV)

export const getBugsnagAppVersion = () =>
  process.env.NEXT_PUBLIC_BUGSNAG_APP_VERSION ??
  process.env.NEXT_PUBLIC_APP_VERSION

export const getBugsnagEnabledReleaseStages = () =>
  process.env.NEXT_PUBLIC_COGNITO_DIAGNOSTICS_LOCAL === '1'
    ? ['production', 'staging', 'development']
    : ['production', 'staging']

// Global callbacks run before notify's callback. Match the constant diagnostic
// message here, before dedicated metadata is attached by that callback.
export const shouldSendLocalBugsnagEvent = (event: {
  errors?: Array<{ errorMessage?: string }>
}) => {
  if (!isLocalBrowser() && getBugsnagReleaseStage() !== 'development')
    return true
  return (
    process.env.NEXT_PUBLIC_COGNITO_DIAGNOSTICS_LOCAL === '1' &&
    /^Cognito (profile|session_check|token_refresh) (failure|burst)$/.test(
      event.errors?.[0]?.errorMessage ?? '',
    )
  )
}
